/* eslint-disable import/prefer-default-export */

export const MIN_SEARCH_LENGTH = 2;
